"use client";
import { useEffect, useState } from "react";
import {
  AccordionDetails,
  AccordionSummary,
  Accordion as MuiAccordion
} from "@mui/material";
import { ExpandMoreRounded as ExpandIcon } from "@mui/icons-material";

import { useStore } from "../../service/mobx";

export default function Accordion({
  heading,
  content,
  index,
  length,
  open,
  onOpen
}) {
  const [expanded, setExpanded] = useState(open || index === 0);
  const { analytics } = useStore();
  const hidden = heading === undefined;

  useEffect(() => {
    onOpen?.(expanded);
  }, [onOpen, expanded]);

  return (
    <MuiAccordion
      elevation={0}
      component="section"
      expanded={expanded}
      sx={{
        m: "0 !important",
        borderBottom: hidden ? undefined : 1,
        borderBottomStyle: hidden ? undefined : "dotted",
        borderBottomColor: hidden ? undefined : "var(--outline-variant)",
        bgcolor: "var(--secondary-container-lowest)",
        "&:before": {
          bgcolor: "transparent"
        },
        "&:hover": {
          cursor: hidden ? "default" : undefined,
          bgcolor:
            hidden || expanded
              ? undefined
              : theme => theme.alpha("var(--surface-container-highest)", 0.3)
        }
      }}
      slotProps={{ transition: { timeout: { enter: 300, exit: 250 } } }}
    >
      <AccordionSummary
        sx={{
          textWrap: "balance",
          px: { compact: 1, expanded: 2 },
          typography: { compact: "titleMd", expanded: "headlineSm" },
          "&:hover": {
            cursor: hidden ? "default !important" : undefined
          }
        }}
        expandIcon={
          hidden ? undefined : (
            <ExpandIcon sx={{ color: "var(--surface-on-variant)" }} />
          )
        }
        onClick={
          hidden
            ? undefined
            : () => {
                const _expanded = !expanded;

                setExpanded(_expanded);
                analytics.track.event(
                  `Section ${_expanded ? "Expand" : "Collapse"}`,
                  {
                    index,
                    heading,
                    percent: (index + 1) / length
                  }
                );
              }
        }
      >
        {heading}
      </AccordionSummary>
      <AccordionDetails
        className="article-section"
        sx={{
          p: 0,
          pb: 1,
          px: { compact: 1, expanded: 3, large: 2 }
        }}
      >
        {content}
      </AccordionDetails>
    </MuiAccordion>
  );
}
